import { render, staticRenderFns } from "./OldHome.vue?vue&type=template&id=bfd8b89c&"
import script from "./OldHome.vue?vue&type=script&lang=js&"
export * from "./OldHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports